import { initializeApp } from 'firebase/app';
import { getMessaging, getToken,deleteToken, Messaging, isSupported} from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyCDM6frJ5XBB_Ikc1EqI3EP6VYYOblYzQk",
    authDomain: "lowerdash-6cce7.firebaseapp.com",
    projectId: "lowerdash-6cce7",
    storageBucket: "lowerdash-6cce7.firebasestorage.app",
    messagingSenderId: "14845217011",
    appId: "1:14845217011:web:67b4a49e65b3c2e716cf86",
    measurementId: "G-89FK2EW2VE"
};

  const firebaseApp = initializeApp(firebaseConfig);

let messaging: Messaging | null = null;

export const getMessagingIfSupported = async (): Promise<Messaging | null> => {
  const supported = await isSupported();
  if (supported && !messaging) {
    messaging = getMessaging(firebaseApp);
  }
  return supported ? messaging : null;
};

export const requestFcmToken = async (swRegistration: ServiceWorkerRegistration): Promise<string | null> => {
  try {
    const messaging = await getMessagingIfSupported();
    if (!messaging) return null;

    if (Notification.permission === 'denied') {
      console.warn('Bildirim izni tarayıcı tarafından engellenmiş.');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Kullanıcı bildirim iznini vermedi.');
      return null;
    }

    const fcmToken = await getToken(messaging, {
      vapidKey: 'BMvZAJoP-gaf2oMPuFeQ9XDoUwQnKVdwQknsuIsU4Jy-VCViTiPhwGrdzCYVWQPmAN4UpKvnAEvT6vxU5iF9HiA',
      serviceWorkerRegistration: swRegistration,
    });

    return fcmToken || null;
  } catch (err) {
    console.error('FCM token alma hatası:', err);
    return null;
  }
};

export const deleteFcmToken = async (): Promise<void> => {
  try {
    const messaging = await getMessagingIfSupported();
    if (!messaging) return;

    await deleteToken(messaging);
    console.log('FCM token silindi.');
  } catch (err) {
    console.error('FCM token silme hatası:', err);
  }
};